import {RouterLink} from '@angular/router';
import {Tour} from '@app/common/interfaces/tour';
import {LngKeys} from "@app/common/enums/lng-keys";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {AppStateService} from '@app/common/services/app-state.service';
import {Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import {TourItemComponent} from '@app/components/tours/tour-item/tour-item.component';

@Component({
  selector: 'app-tours',
  templateUrl: './tours.component.html',
  styleUrls: ['./tours.component.scss'],
  imports: [
    RouterLink,
    TranslatePipe,
    TourItemComponent,
    ReactiveFormsModule,
  ]
})
export class ToursComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  protected readonly appStateService = inject(AppStateService);
  private readonly translateService = inject(TranslateService);

  protected readonly LngKeys = LngKeys;

  @Input() title = 'Destinations';
  @Input() shuffle = false;
  public tours: Tour[] = JSON.parse(JSON.stringify(this.appStateService.tours));
  public formControl = new UntypedFormControl();

  ngOnInit() {
    if (this.shuffle) {
      this.tours = this.onShuffle(this.tours);
    }
    this.onFilterTours();
  }

  private onShuffle(tours: Tour[]): Tour[] {
    for (let i: number = tours.length - 1; i > 0; i--) {
      const j: number = Math.floor(Math.random() * (i + 1));
      [tours[i], tours[j]] = [tours[j], tours[i]];
    }
    return tours.slice(0, 3);
  }

  private onFilterTours() {
    this.formControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: string) => {
        if (!res) {
          this.tours = JSON.parse(JSON.stringify(this.appStateService.tours));
        } else {
          this.tours = JSON.parse(JSON.stringify(this.appStateService.tours)).filter((tour: Tour) => {
            return this.translateService.instant(tour.title).toUpperCase().indexOf(res.toUpperCase()) > -1;
          });
        }
      });
  }

}
